module.exports = __webpack_public_path__ + "img/ba／pic.f2e55779.png";